export default "__VITE_ASSET__WnOhSL62__"